import * as React from 'react'


export interface Props {
    children: React.ReactNode
    size?: string
    open?: boolean
    onClose?: (x: any) => void
}
  
export interface State {
    hide: boolean
}

export class Modal extends React.Component<Props, any> {

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          hide: (this.props.open) ? this.props.open : false,
        }
      }

  public setHidden = () => {
    this.setState({hidden: false})
  }    

  
  public render(): React.ReactNode {
   
    if (!this.props.open) {
        return (<div></div>)
    }

    const size = this.props.size ?? 'w-auto'

    return(
        <div className='w-full h-full flex items-center justify-center fixed top-0 left-0 z-20'>
                <div onClick={this.props.onClose} className={`w-full h-full fixed bg-opacity-75 bg-black z-30`}>
                </div>
                <div className={`${size} min-w-10 h-auto max-h-full min-h-10 bg-white p-4 z-40 overflow-auto rounded-xl`}>
                    {this.props.children}  
                </div>
        </div>
        )
  }  
  
}

export default Modal